import React from 'react';
import menu from './data';

const Menu = ({ menuItems }) => {
  return (
    <section className='section-center'>
      {menuItems.map((dish) => {
        const { id, title, category, price, img, desc } = dish;
        return (
          <article key={id} className='menu-item'>
            <img src={img} alt={title} className='photo' />
            <div className='item-info'>
              <header>
                <h4>{title}</h4>
                <h4 className='price'>{price}</h4>
              </header>
              <p className='item-text'>{desc}</p>
            </div>
          </article>
        );
      })}
    </section>
  );
};

export default Menu;
